import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import EmptyListGap from './components/EmptyListGap.vue'
import FieldTitle from './components/FieldTitle.vue'
import NestedContent from './components/NestedContent.vue'
import AgreementCheckboxInput from './fields/AgreementCheckboxInput/AgreementCheckboxInput.vue'
import BlackWhiteListInput
  from './fields/BlackWhiteListInput/BlackWhiteListInput.vue'
import CheckboxInput from './fields/CheckboxInput/CheckboxInput.vue'
import ChipsInput from './fields/ChipsInput/ChipsInput.vue'
import DatePickerInput
  from './fields/DatePickerInput/DatePickerInput.vue'
import EditorInput from './fields/EditorInput/EditorInput.vue'
import FileInput from './fields/FileInput/FileInput.vue'
import FileUploaderTargetsInput from './fields/FileUploaderTargetsInput/FileUploaderTargetsInput.vue'
import FileUrlsListInput from './fields/FileUrlsListInput/FileUrlsListInput.vue'
import InlinePickerInput from './fields/InlinePickerInput/InlinePickerInput.vue'
import MessageEditorWithMediaInput from './fields/MessageEditorWithMediaInput/MessageEditorWithMediaInput.vue'
import MultiMessageEditorWithMediaInput from './fields/MultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue'
import NumberInput from './fields/NumberInput/NumberInput.vue'
import PasswordInput from './fields/PasswordInput/PasswordInput.vue'
import RadioInput from './fields/RadioInput/RadioInput.vue'
import RangeInput from './fields/RangeInput/RangeInput.vue'
import SelectInput from './fields/SelectInput/SelectInput.vue'
import SwitchInput from './fields/SwitchInput/SwitchInput.vue'
import TextInput from './fields/TextInput/TextInput.vue'
import TextareaInput from './fields/TextareaInput/TextareaInput.vue'
import TimePickerInput
  from './fields/TimePickerInput/TimePickerInput.vue'
import TimeUnitInput from './fields/TimeUnitInput/TimeUnitInput.vue'
import WeekDayPickerInput from './fields/WeekDayPickerInput/WeekDayPickerInput.vue'

@Component({
  components: {
    CheckboxInput,
    ChipsInput,
    EditorInput,
    FileUrlsListInput,
    MultiMessageEditorWithMediaInput,
    MessageEditorWithMediaInput,
    NumberInput,
    RadioInput,
    SelectInput,
    SwitchInput,
    TextareaInput,
    TextInput,
    TimeUnitInput,
    NestedContent,
    FieldTitle,
    DatePickerInput,
    EmptyListGap,
    PasswordInput,
    BlackWhiteListInput,
    TimePickerInput,
    FileInput,
    AgreementCheckboxInput,
    InlinePickerInput,
    RangeInput,
    WeekDayPickerInput,
    FileUploaderTargetsInput,
  },
})
export class UseFields extends Vue {

}

export const store = {
  namespaced: true,

  mutations: {
    // eslint-disable-next-line @typescript-eslint/ban-types
    EXEC(state: any, { key, fn }: { key: string, fn: Function }): void {
      fn()
    },
  },
}
